<app-modal>
  <h1 class="h2">Delete Event</h1>
  <div class="mt-0100 mb-0025">

    <p>Are you sure you want to delete
      <strong>{{ calendarEvent.name }}</strong>
      occuring on
      <strong>{{ calendarEvent.startDate | date:'fullDate' }}</strong>
      at
      <strong>{{ calendarEvent.startDate | date: 'h:mma' | lowercase }}</strong>?
    </p>

    <div class="row dual-btn-row with-gap mt-0100 flexJustify--end">
      <button type="button" class="btn btn--white" (click)="close()">
        Cancel
      </button>
      <button type="button" class="btn btn--red mt-0" (click)="deleteEventClicked()">
        Delete event
      </button>
    </div>

  </div>
</app-modal>
